import { Grid, IconButton, makeStyles } from '@material-ui/core'
import InfoOutlined from 'components/common/icons/InfoOutlined'
import DazzedHeading14 from 'components/common/text/DazzedHeading14'
import Tooltip from 'components/common/Tooltip'
import React from 'react'
import { Skeleton } from '@material-ui/lab'
import useCopilotAccountOwnerId from '../../hooks/useCopilotAccountOwnerId'
import { useFetchPatientBriefCoverageQuery } from 'store/modules/CopilotControl'
import { calculateCopilotUtilization, isBriefCoverageComplete } from '../../patientBriefCoverageLogic'
import { useTranslation } from 'react-i18next'
import SparkleIcon from '../../icons/SparkleIcon'
import BaseWidget from '../../components/common/BaseWidget'
import RoundedLinearProgress from './CopilotUtilizationBar'
import CopilotUtilizationCategories from './CopilotUtilizationCategories'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '12px 20px',
    width: 250,
    borderRadius: 16
  },
  labelContainer: {
    wrap: 'nowrap',
    alignItems: 'center',
    paddingBottom: 10
  },
  tooltipContainer: {
    marginLeft: 5
  },
  tooltip: {
    maxWidth: '280px !important',
    borderRadius: 16,
    boxShadow: '0px 4px 4px 0px #00000040 !important'
  },
  iconContainer: {
    marginRight: 15
  }
}))

const CopilotUtilization = ({ practiceGuidelinesConfiguration = [], isLoadingPracticeGuidelines }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const accountOwnerId = useCopilotAccountOwnerId()
  const {
    currentData: briefCoverage,
    isFetching,
    isError
  } = useFetchPatientBriefCoverageQuery(
    { accountOwnerId },
    { skip: !accountOwnerId, pollingInterval: 30000, refetchOnMountOrArgChange: true }
  )
  const isCoverageReady = !isError && isBriefCoverageComplete(briefCoverage)
  const utilizationValue = calculateCopilotUtilization({ practiceGuidelinesConfiguration, briefCoverage })

  return (
    <BaseWidget carousel={false} className={classes.root}>
      <Grid item className={classes.iconContainer}>
        <SparkleIcon />
      </Grid>
      <Grid container direction="column" wrap="nowrap">
        <Grid container className={classes.labelContainer}>
          <DazzedHeading14 regular>{t('pages.copilotControl.mainPage.copilotUtilization.title')}</DazzedHeading14>
          <Tooltip
            variant="light"
            value={
              <CopilotUtilizationCategories
                practiceGuidelinesConfiguration={practiceGuidelinesConfiguration}
                briefCoverage={isCoverageReady ? briefCoverage : undefined}
                isLoadingBriefCoverage={!briefCoverage && isFetching}
              />
            }
            interactive
            containerClassName={classes.tooltipContainer}
            tooltipContentClassName={classes.tooltip}
            placement="bottom"
            arrow
          >
            <IconButton size="small" aria-label={t('pages.copilotControl.mainPage.copilotUtilization.title')}>
              <InfoOutlined color="#727B8C" />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item>
          {isLoadingPracticeGuidelines || (!briefCoverage && isFetching) ? (
            <Skeleton width="100%" height={12} />
          ) : isCoverageReady ? (
            <RoundedLinearProgress variant="determinate" value={utilizationValue} />
          ) : (
            <DazzedHeading14 regular>{t('general.NA')}</DazzedHeading14>
          )}
        </Grid>
      </Grid>
    </BaseWidget>
  )
}

export default CopilotUtilization
